import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import {
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION_TEXT_KEY,
  USER_PROFILE_PAGE_HEADER_FOOTER_SECONDARY_ACTION_ICON,
  USER_PROFILE_PAGE_HEADER_FOOTER_SECONDARY_ACTION_QA_NAME,
} from '../UserProfilePageHeaderFooter.constants'

function UserProfilePageHeaderFooterSecondaryAction({
  actionHandlers,
  secondaryAction,
}) {
  const { t } = useTranslation()

  return secondaryAction ? (
    <Button.Outlined
      beforeIconProps={{
        Icon: USER_PROFILE_PAGE_HEADER_FOOTER_SECONDARY_ACTION_ICON[
          secondaryAction
        ],
      }}
      qaName={
        USER_PROFILE_PAGE_HEADER_FOOTER_SECONDARY_ACTION_QA_NAME[
          secondaryAction
        ]
      }
      text={t(USER_PROFILE_PAGE_HEADER_FOOTER_ACTION_TEXT_KEY[secondaryAction])}
      onClick={actionHandlers[secondaryAction]}
    />
  ) : null
}

export default UserProfilePageHeaderFooterSecondaryAction
